export function isLottiePayload(value: unknown): value is object {
  if (!value || (typeof value !== 'object')) {
    return false;
  }

  const candidate = value as Record<string, unknown>;

  const version = candidate.v;
  const framerate = candidate.fr;

  return (
    (typeof version === 'string') &&
    (typeof framerate === 'number') &&
    Array.isArray(candidate.layers)
  );
}

export function buildProxyUrl(animationUrl: string): string {
  try {
    const url = new URL(animationUrl, window.location.href);

    if (url.origin !== window.location.origin) {
      return `/api/lottie?url=${encodeURIComponent(url.toString())}`;
    }

    return url.toString();
  } catch {
    return animationUrl;
  }
}
